import { selectAppConfig } from "./selectAppConfig";

export const selectExtraLegals = state => selectAppConfig(state).extra_legals || [];
